import request from "@/utils/request";

export function handleListApi(data) {
    return request({
        url: "/admin/work_kefu",
        method: "get",
        params: data
    });
}

export function handleCreateStoreApi(data) {
    if (data.id) {
        return request({
            url: "/admin/work_kefu/" + data.id,
            method: "put",
            data
        });
    } else {
        return request({
            url: "/admin/work_kefu",
            method: "post",
            data
        });
    }
}

export function handleDeleteApi(data) {
    return request({
        url: "/admin/work_kefu/" + data.id,
        method: "delete"
    });
}

export function getTimeApi(data) {
    return request({
        url: "/admin/get_config_setting",
        method: "get",
        params: data
    });
}

export function setTimeApi(data) {
    return request({
        url: "/admin/set_config_setting",
        method: "post",
        params: data
    });
}


